import clsx from 'clsx';
import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import classes from './switch.module.css';

export interface ISwitchProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  leftLabel: string;
  rightLabel: string;
}

export const Switch = ({
  leftLabel,
  rightLabel,
  checked,
  ...props
}: ISwitchProps) => {
  return (
    <div className="flex items-center space-x-2">
      <span
        className={clsx('text-base font-bold', {
          'text-primary-500': !checked,
        })}
      >
        {leftLabel}
      </span>
      <label className={classes.switch}>
        <input type="checkbox" {...props} checked={checked} />
        <span className={clsx(classes.round, classes.slider)}></span>
      </label>
      <span
        className={clsx('text-base font-bold', { 'text-primary-500': checked })}
      >
        {rightLabel}
      </span>
    </div>
  );
};
